import React from 'react';
import style from './layout.module.scss';

export const Layout = ({children, background = 'white'}) => {
    return(
        <div className={style.container} style={{background}}>
            {children}
        </div>
    )
}